//Color.js



//------------------------------------------------------------------------
//Color object to add correct colors to THREE materials
//------------------------------------------------------------------------

const MaterialColor = { slabs:              0x8FBC8F, 
						columns:            0x87CEFA,
						foundation:         0xCD853F,
						core:               0xe64e3e,
						beams:              0xe521a,
						buildingMesh:       0x799dba,
						buildingOutline:    0x383838,
						pointTextHelper:    0x000000
					}




//------------------------------------------------------------------------
//Export
//------------------------------------------------------------------------

export { MaterialColor }
